var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-amap',{attrs:{"center":_vm.position,"zoom":_vm.zoom}},[_c('el-amap-marker',{attrs:{"position":_vm.position,"label":_vm.label2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }